import Professeur from 'app/entities/personnel/personnel';

const config = {
  VERSION: process.env.VERSION,
};

export default config;

export const SERVER_API_URL = process.env.SERVER_API_URL;

export const AUTHORITIES = {
  ADMIN: 'ROLE_ADMIN',
  USER: 'ROLE_USER',
  DIRECTEUR: 'ROLE_DIRECTEUR',
  DIRECTEUR_ETUDE: 'ROLE_DIRECTEUR_ETUDE',
  COMPTABLE: 'ROLE_COMPTABLE',
  SURVEILLANT_GENERAL: 'ROLE_SURVEILLANT_GENERAL',
  SURVEILLANT: 'ROLE_SURVEILLANT',
  PROFESSEUR: 'ROLE_PROFESSEUR',
  SECRETAIRE: 'ROLE_SECRETAIRE',
  CONTROLEUR: 'ROLE_CONTROLEUR_BUS',
};
export const ROLES = {
  ROLE_ADMIN: 'ADMIN',
  ROLE_USER: 'ADMIN',
  ROLE_DIRECTEUR: 'DIRECTEUR',
  ROLE_DIRECTEUR_ETUDE: 'DIRECTEUR ETUDE',
  ROLE_COMPTABLE: 'COMPTABLE',
  ROLE_SURVEILLANT_GENERAL: 'SURVEILLANT GENERAL',
  ROLE_PROFESSEUR: 'PROFESSEUR',
  ROLE_SECRETAIRE: 'SECRETAIRE',
  CONTROLEUR: 'ROLE_CONTROLEUR_BUS',
};

export const messages = {
  DATA_ERROR_ALERT: 'Internal Error',
};

export const APP_DATE_FORMAT = 'DD/MM/YY HH:mm';
export const APP_TIMESTAMP_FORMAT = 'DD/MM/YY HH:mm:ss';
export const APP_LOCAL_DATE_FORMAT = 'DD/MM/YYYY';
export const APP_LOCAL_MONTH_FORMAT = 'DD/MMM';
export const APP_LOCAL_DATETIME_FORMAT = 'YYYY-MM-DDTHH:mm';
export const APP_LOCAL_DATETIME_FORMAT_Z = 'YYYY-MM-DDTHH:mm Z';
export const APP_WHOLE_NUMBER_FORMAT = '0,0';
export const APP_TWO_DIGITS_AFTER_POINT_NUMBER_FORMAT = '0,0.[00]';
